var $0802ec67729008c5$exports = {};
$0802ec67729008c5$exports = {
    "alert": `Upozornenie`,
    "dismiss": `Zru\u{161}i\u{165}`
};


export {$0802ec67729008c5$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
